import { useEffect, useMemo, useState } from "react";
import modelService from "../api/services/model";

const normalizeKeyword = (value) => {
  if (!value || typeof value !== "string") {
    return null;
  }

  const trimmed = value.trim();
  return trimmed.length ? trimmed : null;
};

const uniqueById = (items) => {
  const seen = new Set();

  return items.filter((item) => {
    if (!item?._id || seen.has(item._id)) {
      return false;
    }

    seen.add(item._id);
    return true;
  });
};

const useSeoTemplates = ({ preferredKeyword, itemCount = 4 }) => {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);

  const candidateKeywords = useMemo(() => {
    const normalized = normalizeKeyword(preferredKeyword);
    return normalized ? [normalized, null] : [null];
  }, [preferredKeyword]);

  useEffect(() => {
    let active = true;

    const loadTemplates = async () => {
      setLoading(true);

      try {
        let collected = [];

        for (const keyword of candidateKeywords) {
          const response = await modelService.getExploreCollections({
            page: 1,
            search: "",
            ...(keyword ? { keyword } : {}),
          });

          const items = uniqueById(response?.data || []);
          if (items.length) {
            collected = items.slice(0, itemCount);
            break;
          }
        }

        if (active) {
          setTemplates(collected);
        }
      } catch (error) {
        if (active) {
          setTemplates([]);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadTemplates();

    return () => {
      active = false;
    };
  }, [candidateKeywords, itemCount]);

  return { templates, loading };
};

export default useSeoTemplates;
